<template>
  <v-container>
    <v-simple-table>
      <template>
        <tbody>
          <tr
            v-for="log in logs"
            :key="log.name"
          >
            <td>{{ log.name }}</td>
            <td>{{ log.fullName }}</td>
            <td>{{ length(log.length) }}</td>
            <td>
              <v-btn
                @click="download(log)"
                :disabled="downloading"
                :loading="downloading"
                icon
              >
                <v-icon>mdi-cloud-download-outline</v-icon>
              </v-btn>
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
  </v-container>
</template>

<script>
import { Logs } from '@/api';

export default {
  data() {
    return {
      logs: [],
      loading: true,
      downloading: false,
    };
  },
  methods: {
    length(size) {
      const units = ['bytes', 'KB', 'MB', 'GB'];
      let i = 0;
      let n = parseInt(size, 10) || 0;

      while (n >= 1024) {
        n /= 1024;
        ++i;
      }

      return `${n.toFixed(i > 0 ? 1 : 0)} ${units[i]}`;
    },
    async download(log) {
      this.downloading = true;
      const anchor = window.document.createElement('a');

      try {
        const { data } = await Logs.download(
          { path: log.fullName },
          { responseType: 'blob' },
        );

        anchor.href = `data:text/plain;charset=utf-8,${window.encodeURIComponent(data)}`;
        anchor.download = log.name;
        anchor.click();
      } catch (e) {
        console.error(e);
      }

      this.downloading = false;
    },
  },
  async created() {
    ({ data: this.logs } = await Logs.fetch());
    this.loading = false;
  },
};
</script>
